// import {
//   createBrowserRouter,
//   createRoutesFromElements,
//   Route,
//   RouterProvider,
// } from "react-router-dom";
// import { Suspense, lazy, createContext, useState, useEffect } from "react";
// import { HelmetProvider } from "react-helmet-async";
// import { MainContextInteface } from "./Components/Interfaces/MainContextInterface";
// import LoadingBar from "./Components/LoadingBar";
// import { CraftsmanDataInterface } from "./Components/Interfaces/CraftsmanDataInterface";
// import { ClientDataInterface } from "./Components/Interfaces/ClientDataInterface";
// import Root from "./Components/Root";
// import Page from "./Components/SEO/Page";
// import { useLocation } from "react-router-dom";
// import { initGA, logPageView } from "./Components/Analytic/Analytics"; // დავამატეთ ანალიტიკის იმპორტი
// import AuthListener from "./Components/AppWriteOAuth/AuthListener";

// // MEASUREMENT ID
// const TRACKING_ID = "G-8GL1SYZL2C";

// const HomePage = lazy(() => import("./Components/Pages/HomePage"));
// const CalculatorPage = lazy(() => import("./Components/Pages/CalculatorPage"));
// const SearchPage = lazy(() => import("./Components/Pages/SearchPage"));
// const RegistrationPage = lazy(
//   () => import("./Components/Pages/RegistrationPage")
// );
// const CategoryPage = lazy(() => import("./Components/Categories/CategoryPage"));
// const CraftsmanProfile = lazy(
//   () => import("./Components/UserCards/CraftsmanProfile")
// );
// const FilteredCraftsmen = lazy(
//   () => import("./Components/Finding/FilteredCraftsmen")
// );
// const CraftsmanRegistration = lazy(
//   () => import("./Components/Registration/CraftsmanRegistration")
// );
// const ClientRegistration = lazy(
//   () => import("./Components/Registration/ClientRegistration")
// );

// const Authorization = lazy(
//   () => import("./Components/Authorization/Authorization")
// );
// const CraftsmanPersonalPage = lazy(
//   () => import("./Components/PersonalPages/CraftsmanPersonalPage")
// );
// const ClientPersonalPage = lazy(
//   () => import("./Components/PersonalPages/ClientPersonalPage")
// );
// const CraftsmanSuccessfulRegistration = lazy(
//   () =>
//     import("./Components/SuccessfulOperations/CraftsmanSuccessfulRegistration")
// );
// const ClientSuccessfulRegistration = lazy(
//   () => import("./Components/SuccessfulOperations/ClientSuccessfulRegistration")
// );
// const SuccessfulVerification = lazy(
//   () => import("./Components/SuccessfulOperations/SuccessfulVerification")
// );
// const Verification = lazy(
//   () => import("./Components/Authorization/Verification")
// );
// const PasswordRecovery = lazy(
//   () => import("./Components/Authorization/PasswordRecovery")
// );
// const PrivacyAndPolicy = lazy(
//   () => import("./Components/PrivacyAndPolicy/PrivacyAndPolicy")
// );

// const QandA = lazy(()=> import("./Components/PrivacyAndPolicy/QandA"));

// const GoogleAccount = lazy(
//   () => import("./Components/PersonalPages/GoogleAccount")
// );

// const ProtectedCraftsmanRoute = lazy(
//   () => import("./Components/Protect/ProtectedUserRoute")
// );
// const UnauthorizedPage = lazy(
//   () => import("./Components/Protect/UnAuthorizedPage")
// );

// const AuthCallback = lazy(()=>import("./Components/AppWriteOAuth/AuthCallback"));

// // გვერდების თვალყურის დევნების კომპონენტი
// function PageViewTracker() {
//   const location = useLocation();

//   useEffect(() => {
//     logPageView(); // Google Analytics
//   }, [location]);

//   return null;
// }

// // დავამატოთ PageViewTracker კომპონენტი Root კომპონენტში
// const RootWithAnalytics = () => {
//   return (
//     <>
//       <PageViewTracker />
//       <Root />
//     </>
//   );
// };

// const router = createBrowserRouter(
//   createRoutesFromElements(
//     <Route path="/" element={<RootWithAnalytics />}>
//       <Route
//         index
//         element={
//           <Page
//             title="ყველა ხელოსანი ერთ სივრცეში | xeloba.ge"
//             description="მოძებნეთ პროფესიონალი ხელოსნები ჩვენთან, გაიმარტივეთ სარემონტო და სამონტაჟო სამუშაოების მოძიება. xeloba.ge გთავაზობთ სანდო ხელოსნების ბაზას საქართველოში."
//             keywords={[
//               "ხელოსნები გამოძახებით",
//               "ხელოსანი გამოძახებით",
//               "ხელობა",
//               "სერვისი",
//               "რემონტი",
//               "სარემონტო მომსახურება",
//               "მონტაჟი",
//               "ხელოსნები",
//               "სარემონტო ბლოგი",
//               "პროფესიონალი ხელოსნები",
//               "ხელოსნის დაქირავება",
//               "სახლის რემონტი",
//             ]}
//             author="xeloba.ge"
//             canonicalUrl="https://xeloba.ge/"
//             image="https://xeloba.ge/logo.ico"
//             noindex={false}
//             structuredData={{
//               "@context": "https://schema.org",
//               "@type": "WebSite",
//               name: "xeloba.ge",
//               url: "https://xeloba.ge",
//               description: "ხელოსნების პოვნისა და დაქირავების პლატფორმა",
//               potentialAction: {
//                 "@type": "SearchAction",
//                 target: {
//                   "@type": "EntryPoint",
//                   urlTemplate:
//                     "https://xeloba.ge/search?q={search_term_string}",
//                 },
//                 "query-input": "required name=search_term_string",
//               },
//               author: {
//                 "@type": "Organization",
//                 name: "xeloba.ge",
//                 logo: {
//                   "@type": "ImageObject",
//                   url: "https://xeloba.ge/assets/logo.png",
//                   width: "180",
//                   height: "60",
//                 },
//                 sameAs: [
//                   "https://www.facebook.com/people/%E1%83%AE%E1%83%94%E1%83%9A%E1%83%9D%E1%83%91%E1%83%90-Xeloba/61555048217915/",
//                   "https://www.instagram.com/xeloba7/?igsh=MWFrNmxzemt4ZmgzZA%3D%3D#",
//                 ],
//               },
//               offers: {
//                 "@type": "AggregateOffer",
//                 itemOffered: {
//                   "@type": "Service",
//                   name: "სარემონტო მომსახურება",
//                   description:
//                     "პროფესიონალი ხელოსნების მომსახურება საქართველოში",
//                 },
//               },
//             }}
//           >
//             <HomePage />
//           </Page>
//         }
//       />

//       <Route
//         path="calculator"
//         element={
//           <Page
//             title="კალკულატორი - სარემონტო ხარჯების გამოთვლა | xeloba.ge"
//             description="კალკულატორი სარემონტო ხარჯების გამოსათვლელად. გამოთვალეთ რემონტის დაახლოებითი ღირებულება და ფართობი სწრაფად. დაზოგეთ დრო და ფული სამუშაოების დაგეგმვისას."
//             keywords={[
//               "სარემონტო ხარჯები",
//               "სარემონტო ფართობი",
//               "სარემონტო კალკულატორი",
//               "ფასების გამოთვლა",
//               "ფართობის გამოთვლა",
//               "რემონტი",
//               "ხელოსანი",
//               "ბინის რემონტის ხარჯი",
//               "რემონტის ბიუჯეტი",
//               "მასალების ღირებულება",
//               "რემონტის დაგეგმვა",
//             ]}
//             author="xeloba.ge"
//             canonicalUrl="https://xeloba.ge/calculator"
//             image="https://xeloba.ge/assets/logo.png"
//             noindex={false}
//             structuredData={{
//               "@context": "https://schema.org",
//               "@type": "CalculatorService",
//               name: "კალკულატორი - xeloba.ge",
//               url: "https://xeloba.ge/calculator",
//               description: "კალკულატორი სარემონტო ფართობისა და ღირებულების გამოსათვლელად",
//               provider: {
//                 "@type": "Organization",
//                 name: "xeloba.ge",
//                 url: "https://xeloba.ge",
//               },
//               offers: {
//                 "@type": "Offer",
//                 price: "0",
//                 priceCurrency: "GEL",
//                 availability: "https://schema.org/InStock",
//               },
//               mainEntityOfPage: {
//                 "@type": "WebPage",
//                 "@id": "https://xeloba.ge/calculator",
//               },
//             }}
//           >
//             <CalculatorPage />
//           </Page>
//         }
//       />

//       <Route
//         path="search"
//         element={
//           <Page
//             title="ხელოსნების ძებნა | xeloba.ge - იპოვეთ სანდო ხელოსანი თქვენი პროექტისთვის"
//             description="მოძებნეთ პროფესიონალი ხელოსნები რეგიონის, პროფესიის, გამოცდილების, ფასისა და რეიტინგის მიხედვით. ნახეთ გამოხმაურებები და დაუკავშირდით პირდაპირ."
//             keywords={[
//               "ხელოსნის ძებნა",
//               "მომსახურების მიმწოდებლები",
//               "პროფესიონალები",
//               "გაფილტვრა",
//               "რეიტინგი",
//               "გამოცდილება",
//               "ხელოსნები თბილისში",
//               "ხელოსნები რუსთავში",
//               "ხელოსნები გორში",
//               "ხელოსნები ქუთაისში",
//               "ხელოსნები ბათუმში",
//             ]}
//             author="xeloba.ge"
//             canonicalUrl="https://xeloba.ge/search"
//             image="https://xeloba.ge/assets/logo.png"
//             noindex={false}
//             structuredData={{
//               "@context": "https://schema.org",
//               "@type": "SearchResultsPage",
//               name: "ხელოსნების ძებნა",
//               description: "ხელოსნების ძებნა სხვადასხვა კრიტერიუმით",
//               mainEntity: {
//                 "@type": "ItemList",
//               },
//               potentialAction: {
//                 "@type": "SearchAction",
//                 target: {
//                   "@type": "EntryPoint",
//                   urlTemplate:
//                     "https://xeloba.ge/search?q={search_term_string}",
//                 },
//                 "query-input": "required name=search_term_string",
//               },
//             }}
//           >
//             <SearchPage />
//           </Page>
//         }
//       />

//       <Route
//         path="registration"
//         element={
//           <Page
//             title="რეგისტრაცია ხელოსნებისა და კლიენტებისთვის | xeloba.ge"
//             description="დარეგისტრირდით უფასოდ xeloba.ge-ზე როგორც ხელოსანი ან კლიენტი. მიიღეთ წვდომა საუკეთესო სამუშაო შესაძლებლობებთან და ხელოსნების ფართო ქსელთან."
//             keywords={[
//               "რეგისტრაცია",
//               "ხელოსნის რეგისტრაცია",
//               "კლიენტის რეგისტრაცია",
//               "გაწევრიანება",
//               "პლატფორმა",
//               "უფასო რეგისტრაცია",
//               "სარემონტო სერვისი",
//               "ხელობა",
//               "ანგარიშის შექმნა",
//               "ხელოსნების პლატფორმა",
//             ]}
//             author="xeloba.ge"
//             canonicalUrl="https://xeloba.ge/registration"
//             image="https://xeloba.ge/registrationImg.jpg"
//             noindex={false}
//             structuredData={{
//               "@context": "https://schema.org",
//               "@type": "WebPage",
//               name: "რეგისტრაცია ხელოსნებისა და კლიენტებისთვის",
//               description: "ახალი მომხმარებლის რეგისტრაცია xeloba.ge-ზე",
//               mainEntity: {
//                 "@type": "WebPageElement",
//                 isPartOf: {
//                   "@type": "WebSite",
//                   name: "xeloba.ge",
//                   url: "https://xeloba.ge",
//                 },
//                 offers: {
//                   "@type": "Offer",
//                   price: "0",
//                   priceCurrency: "GEL",
//                   availability: "https://schema.org/InStock",
//                   description: "უფასო რეგისტრაცია xeloba.ge-ზე",
//                 },
//               },
//             }}
//           >
//             <RegistrationPage />
//           </Page>
//         }
//       />

//       <Route path="category/:name" element={<CategoryPage />} />
//       <Route path="craftsman/:userID" element={<CraftsmanProfile />} />
//       <Route path="filter" element={<FilteredCraftsmen />} />

//       <Route
//         path="registration/craftsman-registration"
//         element={
//     <Page
//       title="ხელოსნის რეგისტრაცია | xeloba.ge - გაწევრიანდით პროფესიონალი ხელოსნების ქსელში"
//       description="დარეგისტრირდით ხელოსნად xeloba.ge-ზე უფასოდ. მიიღეთ ახალი შეკვეთები, გაზარდეთ თქვენი საქმიანობის მასშტაბი და დაუკავშირდით კლიენტებს პირდაპირ."
//       keywords={[
//         "ხელოსნის რეგისტრაცია",
//         "ხელოსნების პლატფორმა",
//         "სარემონტო სერვისი",
//         "პროფესიონალი ხელოსანი",
//         "შეკვეთების მიღება",
//         "ხელოსნის ანგარიშის შექმნა",
//         "უფასო რეგისტრაცია",
//         "ხელობა",
//         "სამუშაოს პოვნა",
//         "კლიენტებთან დაკავშირება"
//       ]}
//       author="xeloba.ge"
//       canonicalUrl="https://xeloba.ge/registration/craftsman-registration"
//       image="https://xeloba.ge/registrationImg.jpg"
//       noindex={false}
//       structuredData={{
//         "@context": "https://schema.org",
//         "@type": "WebPage",
//         "name": "ხელოსნის რეგისტრაცია",
//         "description": "ხელოსნის რეგისტრაცია xeloba.ge პლატფორმაზე",
//         "mainEntity": {
//           "@type": "RegistrationForm",
//           "name": "ხელოსნის რეგისტრაციის ფორმა",
//           "description": "ახალი ხელოსნის რეგისტრაცია",
//           "provider": {
//             "@type": "Organization",
//             "name": "xeloba.ge",
//             "url": "https://xeloba.ge"
//           }
//         },
//         "breadcrumb": {
//           "@type": "BreadcrumbList",
//           "itemListElement": [
//             {
//               "@type": "ListItem",
//               "position": 1,
//               "name": "მთავარი",
//               "item": "https://xeloba.ge/"
//             },
//             {
//               "@type": "ListItem", 
//               "position": 2,
//               "name": "რეგისტრაცია",
//               "item": "https://xeloba.ge/registration"
//             },
//             {
//               "@type": "ListItem",
//               "position": 3,
//               "name": "ხელოსნის რეგისტრაცია"
//             }
//           ]
//         }
//       }}
//     >
//       <CraftsmanRegistration />
//     </Page>
//   }
//       />

//       <Route
//         path="registration/client-registration"
//          element={
//     <Page
//       title="კლიენტის რეგისტრაცია | xeloba.ge - მოიძიეთ სანდო ხელოსნები"
//       description="დარეგისტრირდით კლიენტად xeloba.ge-ზე და მოიძიეთ პროფესიონალი ხელოსნები თქვენი საჭიროებისთვის. დაუკავშირდით ხელოსნებს პირდაპირ."
//       keywords={[
//         "კლიენტის რეგისტრაცია",
//         "ხელოსნის მოძიება",
//         "სარემონტო მომსახურება",
//         "ხელოსნებთან დაკავშირება",
//         "პროფესიონალური მომსახურება",
//         "სამუშაოს შეკვეთა",
//         "უფასო რეგისტრაცია"
//       ]}
//       author="xeloba.ge"
//       canonicalUrl="https://xeloba.ge/registration/client-registration"
//       image="https://xeloba.ge/logo.ico"
//       noindex={false}
//       structuredData={{
//         "@context": "https://schema.org",
//         "@type": "WebPage",
//         "name": "კლიენტის რეგისტრაცია",
//         "description": "კლიენტის რეგისტრაცია xeloba.ge პლატფორმაზე"
//       }}
//     >
//       <ClientRegistration />
//     </Page>
//   }
//       />

//       <Route
//         path="craftsman-registration/successful"
//         element={<CraftsmanSuccessfulRegistration />}
//       />

//       <Route
//         path="client-registration/successful"
//         element={<ClientSuccessfulRegistration />}
//       />

//       <Route
//         path="authorization"
//         element={
//           <Page
//             title="ავტორიზაცია | xeloba.ge - შედით თქვენს ანგარიშზე"
//             description="შედით თქვენს ანგარიშზე xeloba.ge-ზე. დაუკავშირდით პროფესიონალ ხელოსნებს ან მიიღეთ ახალი შეკვეთები."
//             keywords={[
//               "ავტორიზაცია",
//               "შესვლა",
//               "მომხმარებელი",
//               "პირადი პროფილი",
//               "კაბინეტი",
//               "ხელოსნის ანგარიში",
//               "კლიენტის ანგარიში",
//               "პროფილზე შესვლა",
//             ]}
//             author="xeloba.ge"
//             canonicalUrl="https://xeloba.ge/authorization"
//             image="https://xeloba.ge/assets/logo.png"
//             noindex={true}
//             structuredData={{
//               "@context": "https://schema.org",
//               "@type": "LoginAction",
//               target: {
//                 "@type": "EntryPoint",
//                 urlTemplate: "https://xeloba.ge/authorization",
//                 actionPlatform: "https://schema.org/WebPlatform",
//               },
//               description: "მომხმარებლის ავტორიზაცია xeloba.ge-ზე",
//               provider: {
//                 "@type": "Organization",
//                 name: "xeloba.ge",
//                 url: "https://xeloba.ge",
//               },
//             }}
//           >
//             <Authorization />
//           </Page>
//         }
//       />

//       <Route
//         path="verification/successful/:user_Id"
//         element={<SuccessfulVerification />}
//       />

//       <Route
//         path="craftsman/personal-page/:external_Id"
//         element={
//           <ProtectedCraftsmanRoute>
//             <CraftsmanPersonalPage />
//           </ProtectedCraftsmanRoute>
//         }
//       />

//       <Route
//         path="client/personal-page/:external_Id"
//         element={
//           <ProtectedCraftsmanRoute>
//             <ClientPersonalPage />
//           </ProtectedCraftsmanRoute>
//         }
//       />

//       <Route path="google-account" element={<GoogleAccount />} />

//       <Route path="/auth/callback" element={<AuthCallback />} />

//       <Route
//         path="verification/:user_Id/:phone_number"
//         element={<Verification />}
//       />

//       <Route path="unauthorized" element={<UnauthorizedPage />} />

//       <Route
//         path="password-recovery"
//         element={
//           <Page
//             title="პაროლის აღდგენა | xeloba.ge - აღადგინეთ წვდომა თქვენს ანგარიშზე"
//             description="დაგავიწყდათ პაროლი? აღადგინეთ თქვენი xeloba.ge-ს ანგარიშის პაროლი მარტივად და უსაფრთხოდ რამდენიმე წუთში."
//             keywords={[
//               "პაროლის აღდგენა",
//               "ანგარიშის მართვა",
//               "უსაფრთხოება",
//               "დაგავიწყდა პაროლი",
//               "პაროლის განახლება",
//               "ანგარიშზე წვდომა",
//               "პაროლის შეცვლა",
//             ]}
//             author="xeloba.ge"
//             canonicalUrl="https://xeloba.ge/password-recovery"
//             image="https://xeloba.ge/assets/logo.png"
//             noindex={false}
//             structuredData={{
//               "@context": "https://schema.org",
//               "@type": "HowTo",
//               name: "პაროლის აღდგენა xeloba.ge-ზე",
//               description: "მომხმარებლის პაროლის აღდგენის პროცესი",
//               step: [
//                 {
//                   "@type": "HowToStep",
//                   name: "შეიყვანეთ ტელეფონის ნომერი",
//                   text: "შეიყვანეთ თქვენი რეგისტრირებული ტელეფონის ნომერი",
//                 },
//                 {
//                   "@type": "HowToStep",
//                   name: "შეიყვანეთ ახალი პაროლი",
//                   text: "შექმენით ახალი, ძლიერი პაროლი",
//                 },
//                 {
//                   "@type": "HowToStep",
//                   name: "გაიმეორეთ პაროლი",
//                   text: "პაროლი ზუსტად უნდა ემთხვეოდეს ახლად შექმნილ პაროლს",
//                 },
//                 {
//                   "@type": "HowToStep",
//                   name: "დაადასტურეთ",
//                   text: "დააჭირეთ აღდგენის ღილაკს და შეიყვანეთ ერთჯერადი კოდი, რომელიც თქვენს ნომერზე გამოიგზავნა",
//                 },
//               ],
//             }}
//           >
//             <PasswordRecovery />
//           </Page>
//         }
//       />

//       <Route
//         path="privacy-and-policy"
//         element={
//           <Page
//             title="კონფიდენციალურობის პოლიტიკა | xeloba.ge - თქვენი პირადი ინფორმაციის დაცვა"
//             description="გაეცანით xeloba.ge-ს კონფიდენციალურობის პოლიტიკას. ინფორმაცია იმის შესახებ, თუ როგორ ვაგროვებთ, ვიყენებთ და ვიცავთ თქვენს პერსონალურ მონაცემებს."
//             keywords={[
//               "კონფიდენციალურობის პოლიტიკა",
//               "პირადი მონაცემები",
//               "უსაფრთხოება",
//               "მონაცემთა დაცვა",
//               "პირადულობა",
//               "პოლიტიკა",
//               "წესები",
//               "მომხმარებლის უფლებები",
//             ]}
//             author="xeloba.ge"
//             canonicalUrl="https://xeloba.ge/privacy-and-policy"
//             image="https://xeloba.ge/assets/logo.png"
//             noindex={false}
//             structuredData={{
//               "@context": "https://schema.org",
//               "@type": "WebPage",
//               name: "კონფიდენციალურობის პოლიტიკა",
//               description: "xeloba.ge-ს კონფიდენციალურობის პოლიტიკა",
//               mainEntityOfPage: {
//                 "@type": "WebPage",
//                 "@id": "https://xeloba.ge/privacy-and-policy",
//               },
//               publisher: {
//                 "@type": "Organization",
//                 name: "xeloba.ge",
//                 logo: {
//                   "@type": "ImageObject",
//                   url: "https://xeloba.ge/images/logo.png",
//                 },
//               },
//             }}
//           >
//             <PrivacyAndPolicy />
//           </Page>
//         }
//       />

// <Route path="Q&A" element={<QandA />} />
//     </Route>
//   )
// );

// export const MainContext = createContext<MainContextInteface>({
//   menuBar: false,
//   setMenuBar: () => {},
//   selectedNavigation: "home",
//   setSelectedNavigation: () => {},
//   searchByCity: "",
//   setSearchByCity: () => {},
//   searchByDistrict: "",
//   setSearchByDistrict: () => {},
//   searchByProfession: "",
//   setSearchByProfession: () => {},
//   searchByVerification: "",
//   setSearchByVerification: () => {},
//   searchByExperience: "",
//   setSearchByExperience: () => {},
//   searchByPriceFrom: "",
//   setSearchByPriceFrom: () => {},
//   searchByPriceUpTo: "",
//   setSearchByPriceUpTo: () => {},
//   getCraftsmenData: [],
//   getClientData: [],
//   serverBaseUrl: "",
//   titleForCategory: "",
//   setTitleForCategory: () => {},
//   loading: true,
//   filteredCraftsmen: [],
//   totalPages: 0,
//   errorForFilter: "",
//   currentPage: 1,
//   setCurrentPage: () => {},
//   totalCraftsmen: 0,
//   scrolled: false,
//   setScrolled: () => {},
// });

// interface PaginatedResponse {
//   count: number;
//   next: string | null;
//   previous: string | null;
//   results: CraftsmanDataInterface[];
// }

// function App() {
//   const [menuBar, setMenuBar] = useState<boolean>(false);
//   const [selectedNavigation, setSelectedNavigation] = useState<string>("home");
//   const [searchByCity, setSearchByCity] = useState<string>("");
//   const [searchByDistrict, setSearchByDistrict] = useState<string>("");
//   const [searchByProfession, setSearchByProfession] = useState<string>("");
//   const [searchByVerification, setSearchByVerification] = useState<string>("");
//   const [searchByExperience, setSearchByExperience] = useState<string>("");
//   const [searchByPriceFrom, setSearchByPriceFrom] = useState<string>("");
//   const [searchByPriceUpTo, setSearchByPriceUpTo] = useState<string>("");
//   const [titleForCategory, setTitleForCategory] = useState<string>("");
//   const [scrolled, setScrolled] = useState(false);
//   const [loading, setLoading] = useState<boolean>(true);
//   const [filteredCraftsmen, setFilteredCraftsmen] = useState<
//     CraftsmanDataInterface[]
//   >([]);
//   const [totalCraftsmen, setTotalCraftsmen] = useState<number>(0);
//   const [totalPages, setTotalPages] = useState<number>(0);
//   const [errorForFilter, setErrorForFilter] = useState<string>("");
//   const pageSize = 24; // ერთ გვერდზე გამოსაჩენი ხელოსნების რაოდენობა
//   const [currentPage, setCurrentPage] = useState<number>(1);

//   const [getCraftsmenData, setGetCraftsmenData] = useState<
//     CraftsmanDataInterface[]
//   >([]);
//   const [getClientData, setGetClientData] = useState<ClientDataInterface[]>([]);
//   const serverBaseUrl = "https://xeloba.ge/Y2BQDEDHzHua2ls/";
//   // const serverBaseUrl = "http://localhost:8000/xelapi/";

//   // Google Analytics ინიციალიზაცია
//   useEffect(() => {
//     initGA(TRACKING_ID);
//     logPageView(); // პირველადი გვერდის ნახვის დაფიქსირება

//   }, []);

//   //get craftsman data
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`${serverBaseUrl}craftsman/`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const responseData: CraftsmanDataInterface[] = await response.json();
//         setGetCraftsmenData(responseData);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };
//     fetchData();
//   }, []);

//   //get client data
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await fetch(`${serverBaseUrl}client/`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const responseData = await response.json();

//         // Type assertion: ვუთითებთ, რომ responseData არის ClientDataInterface ტიპის ობიექტი.
//         const clientArray = Object.values(
//           responseData
//         ) as ClientDataInterface[];

//         setGetClientData(clientArray); // ახლა ტიპები შესაბამისობაშია.
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };
//     fetchData();
//   }, []);

//   //ხელოსნების გაფილტვრა პროფესიების მიხედვით და კატეგორიებად დაყოფა.
//   useEffect(() => {
//     const fetchCraftsmen = async () => {
//       if (!titleForCategory) {
//         setLoading(false);
//         setErrorForFilter("კატეგორია ვერ მოიძებნა");
//         return;
//       }

//       try {
//         setLoading(true);

//         // API-ის მოთხოვნა პროფესიით გაფილტრული ხელოსნების მისაღებად
//         const response = await fetch(
//           `${serverBaseUrl}get-craftsmen-by-profession/?profession=${encodeURIComponent(
//             titleForCategory
//           )}&page=${currentPage}&page_size=${pageSize}`
//         );

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const data: PaginatedResponse = await response.json();
//         // მიღებული მონაცემების დამუშავება
//         setFilteredCraftsmen(data.results);
//         setTotalCraftsmen(data.count);

//         // გამოვთვალოთ გვერდების საერთო რაოდენობა
//         setTotalPages(Math.ceil(data.count / pageSize));
//         setErrorForFilter("");
//       } catch (error) {
//         console.error("Error fetching craftsmen:", error);
//         setErrorForFilter("მონაცემების მიღება ვერ მოხერხდა");
//         setFilteredCraftsmen([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCraftsmen();
//   }, [titleForCategory, currentPage, serverBaseUrl, pageSize]);

//   //ხელოსნების ფილტრაცია
//   const fetchFilteredCraftsmen = async () => {
//     // თუ კატეგორიის გვერდზე ვიმყოფებით და titleForCategory არის განსაზღვრული,
//     // არ გამოვიყენოთ ეს ფუნქცია (იმის მაგივრად გამოიყენება fetchCraftsmen)
//     if (titleForCategory) {
//       return;
//     }

//     setLoading(true);
//     setErrorForFilter("");

//     try {
//       // ვქმნით ახალ URLSearchParams ობიექტს API მოთხოვნისთვის
//       const params = new URLSearchParams();

//       // ვამატებთ გვერდის ნომერს
//       params.append("page", currentPage.toString());

//       // ფილტრის პარამეტრებს ვამატებთ მხოლოდ იმ შემთხვევაში, თუ ისინი განსაზღვრულია
//       if (searchByCity) params.append("searchByCity", searchByCity);
//       if (searchByDistrict) params.append("searchByDistrict", searchByDistrict);
//       if (searchByProfession)
//         params.append("searchByProfession", searchByProfession);
//       if (searchByVerification)
//         params.append("searchByVerification", searchByVerification);
//       if (searchByExperience)
//         params.append("searchByExperience", searchByExperience);
//       if (searchByPriceFrom)
//         params.append("searchByPriceFrom", searchByPriceFrom);
//       if (searchByPriceUpTo)
//         params.append("searchByPriceUpTo", searchByPriceUpTo);

//       // API მოთხოვნის გაგზავნა
//       const response = await fetch(
//         `${serverBaseUrl}get-filtered-craftsmen/?${params}`
//       );

//       if (!response.ok) {
//         // არასწორი გვერდის შემთხვევაში (404), ვატრიალებთ ხელახალი მოთხოვნით, პირველ გვერდზე
//         if (response.status === 404 && currentPage > 1) {
//           setCurrentPage(1);
//           return; // გავდივართ ფუნქციიდან, რადგან setCurrentPage გამოიწვევს useEffect-ის ხელახალ გაშვებას
//         }
//         // throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const data: PaginatedResponse = await response.json();

//       // მიღებული მონაცემების დამუშავება
//       setFilteredCraftsmen(data.results);
//       setTotalCraftsmen(data.count);

//       // გვერდების რაოდენობის გამოთვლა
//       const pages = Math.ceil(data.count / pageSize);
//       setTotalPages(pages);

//       // თუ მიმდინარე გვერდი აღემატება არსებული გვერდების რაოდენობას, ვაბრუნებთ პირველ გვერდზე
//       if (currentPage > pages && pages > 0) {
//         setCurrentPage(1);
//       }

//       setErrorForFilter("");
//     } catch (err) {
//       console.error("Error fetching filtered craftsmen:", err);
//       setErrorForFilter(
//         "მონაცემების ჩატვირთვა ვერ მოხერხდა. გთხოვთ, სცადოთ მოგვიანებით."
//       );
//       setFilteredCraftsmen([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // useEffect მოდიფიკაცია - დავამატოთ დამოკიდებულების მასივში ყველა ცვლადი,
//   useEffect(() => {
//     // კატეგორიის გვერდზე რომ არ იმუშაოს ამ ფუნქციამ
//     if (!titleForCategory) {
//       fetchFilteredCraftsmen();
//     }
//   }, [
//     currentPage,
//     serverBaseUrl,
//     pageSize,
//     searchByCity,
//     searchByDistrict,
//     searchByProfession,
//     searchByVerification,
//     searchByExperience,
//     searchByPriceFrom,
//     searchByPriceUpTo,
//     titleForCategory,
//   ]);

//   return (
//     <HelmetProvider>
//       <div className="App">
//         <AuthListener />
//         <Suspense fallback={<LoadingBar />}>
//           <MainContext.Provider
//             value={{
//               getCraftsmenData,
//               getClientData,
//               menuBar,
//               setMenuBar,
//               selectedNavigation,
//               setSelectedNavigation,
//               searchByCity,
//               setSearchByCity,
//               searchByDistrict,
//               setSearchByDistrict,
//               searchByProfession,
//               setSearchByProfession,
//               searchByVerification,
//               setSearchByVerification,
//               searchByExperience,
//               setSearchByExperience,
//               searchByPriceFrom,
//               setSearchByPriceFrom,
//               searchByPriceUpTo,
//               setSearchByPriceUpTo,
//               serverBaseUrl,
//               titleForCategory,
//               setTitleForCategory,
//               loading,
//               filteredCraftsmen,
//               totalPages,
//               errorForFilter,
//               currentPage,
//               setCurrentPage,
//               totalCraftsmen,
//               scrolled,
//               setScrolled
//             }}
//           >
//             <RouterProvider router={router} />
//           </MainContext.Provider>
//         </Suspense>
//       </div>
//     </HelmetProvider>
//   );
// }

// export default App;















////////////////
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { Suspense, lazy, createContext, useState, useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { MainContextInteface } from "./Components/Interfaces/MainContextInterface";
import LoadingBar from "./Components/LoadingBar";
import { CraftsmanDataInterface } from "./Components/Interfaces/CraftsmanDataInterface";
import { ClientDataInterface } from "./Components/Interfaces/ClientDataInterface";
import Root from "./Components/Root";
import Page from "./Components/SEO/Page";
import { useLocation } from "react-router-dom";
import { initGA, logPageView } from "./Components/Analytic/Analytics"; // დავამატეთ ანალიტიკის იმპორტი
import AuthListener from "./Components/AppWriteOAuth/AuthListener";
import { NotificationsProvider } from './Components/Notifications/NotificationsContext';

// MEASUREMENT ID
const TRACKING_ID = "G-8GL1SYZL2C";

const HomePage = lazy(() => import("./Components/Pages/HomePage"));
const CalculatorPage = lazy(() => import("./Components/Pages/CalculatorPage"));
const SearchPage = lazy(() => import("./Components/Pages/SearchPage"));
const RegistrationPage = lazy(
  () => import("./Components/Pages/RegistrationPage")
);
const CategoryPage = lazy(() => import("./Components/Categories/CategoryPage"));
const CraftsmanProfile = lazy(
  () => import("./Components/UserCards/CraftsmanProfile")
);
const FilteredCraftsmen = lazy(
  () => import("./Components/Finding/FilteredCraftsmen")
);
const CraftsmanRegistration = lazy(
  () => import("./Components/Registration/CraftsmanRegistration")
);
const ClientRegistration = lazy(
  () => import("./Components/Registration/ClientRegistration")
);

const Authorization = lazy(
  () => import("./Components/Authorization/Authorization")
);
const CraftsmanPersonalPage = lazy(
  () => import("./Components/PersonalPages/CraftsmanPersonalPage")
);
const ClientPersonalPage = lazy(
  () => import("./Components/PersonalPages/ClientPersonalPage")
);
const CraftsmanSuccessfulRegistration = lazy(
  () =>
    import("./Components/SuccessfulOperations/CraftsmanSuccessfulRegistration")
);
const ClientSuccessfulRegistration = lazy(
  () => import("./Components/SuccessfulOperations/ClientSuccessfulRegistration")
);
const SuccessfulVerification = lazy(
  () => import("./Components/SuccessfulOperations/SuccessfulVerification")
);
const Verification = lazy(
  () => import("./Components/Authorization/Verification")
);
const PasswordRecovery = lazy(
  () => import("./Components/Authorization/PasswordRecovery")
);
const PrivacyAndPolicy = lazy(
  () => import("./Components/PrivacyAndPolicy/PrivacyAndPolicy")
);

const QandA = lazy(()=> import("./Components/PrivacyAndPolicy/QandA"));

const CookiesPolicy = lazy(()=> import("./Components/PrivacyAndPolicy/CookiesPolicy"));

const GoogleAccount = lazy(
  () => import("./Components/PersonalPages/GoogleAccount")
);

const FBAccount = lazy(()=> import("./Components/PersonalPages/FBAccount"));

const ProtectedCraftsmanRoute = lazy(
  () => import("./Components/Protect/ProtectedUserRoute")
);
const UnauthorizedPage = lazy(
  () => import("./Components/Protect/UnAuthorizedPage")
);

const AuthCallback = lazy(()=>import("./Components/AppWriteOAuth/AuthCallback"));

const FBAuthCallback = lazy(()=> import("./Components/FacebookOAuth/FBAuthCallback"));

const VIPManagerPage = lazy(()=>import("./Components/Pages/VIPManagerPage"));

const PartnerCompanies = lazy(() => import("./Components/Partners/PartnerCompanies"));

const JobRequestCreate = lazy(() => import("./Components/JobRequestsCreate/JobRequestCreate"));

const JobRequestList = lazy(() => import("./Components/JobRequestList/JobRequestList"));

const JobRequestDetail = lazy(() => import("./Components/JobRequestDetails/JobRequestDetail"));

const MyJobRequests = lazy(() => import("./Components/MyJobRequests/MyJobRequests"));

const CraftsmanBidCreate = lazy(() => import("./Components/CraftsmanBidCreate/CraftsmanBidCreate"));

const BidPackages = lazy(() => import("./Components/BidPackages/BidPackages"));

const BidPurchase = lazy(() => import("./Components/BidPackages/BidPurchase"));

const BidTransactions = lazy(() => import("./Components/BidTransactions/BidTransactions"));

const ProtectedCraftsmanOnlyRoute = lazy(
  () => import("./Components/Protect/ProtectedCraftsmanOnlyRoute")
);

const CraftsmanOnlyPage = lazy(
  () => import("./Components/Protect/CraftsmanOnlyPage")
);

const ProtectedRoute = lazy(
  () => import("./Components/Protect/ProtectedRoute")
);

// გვერდების თვალყურის დევნების კომპონენტი
function PageViewTracker() {
  const location = useLocation();

   useEffect(() => {
    // მხოლოდ მაშინ ვტრაკოთ page view თუ Analytics ჩართულია
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    const analyticsEnabled = localStorage.getItem('analyticsEnabled');
    
    if (cookiesAccepted === 'all' || 
        (cookiesAccepted === 'custom' && analyticsEnabled === 'true')) {
      // console.log('📊 Page view tracked:', location.pathname);
      logPageView();
    } 
    // else {
    //   console.log('⚠️ Page view NOT tracked - no analytics consent');
    // }
  }, [location]);

  return null;
}

// დავამატოთ PageViewTracker კომპონენტი Root კომპონენტში
const RootWithAnalytics = () => {
  return (
    <>
      <PageViewTracker />
      <Root />
    </>
  );
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<RootWithAnalytics />}>
      <Route
        index
        element={
          <Page
            title="ყველა ხელოსანი ერთ სივრცეში | xeloba.ge"
            description="მოძებნეთ პროფესიონალი ხელოსნები ჩვენთან, გაიმარტივეთ სარემონტო და სამონტაჟო სამუშაოების მოძიება. xeloba.ge გთავაზობთ სანდო ხელოსნების ბაზას საქართველოში."
            keywords={[
              "ხელოსნები გამოძახებით",
              "ხელოსანი გამოძახებით",
              "ხელობა",
              "სერვისი",
              "რემონტი",
              "სარემონტო მომსახურება",
              "მონტაჟი",
              "ხელოსნები",
              "სარემონტო ბლოგი",
              "პროფესიონალი ხელოსნები",
              "ხელოსნის დაქირავება",
              "სახლის რემონტი",
            ]}
            author="xeloba.ge"
            canonicalUrl="https://xeloba.ge/"
            image="https://xeloba.ge/logo.ico"
            noindex={false}
            structuredData={{
              "@context": "https://schema.org",
              "@type": "WebSite",
              name: "xeloba.ge",
              url: "https://xeloba.ge",
              description: "ხელოსნების პოვნისა და დაქირავების პლატფორმა",
              potentialAction: {
                "@type": "SearchAction",
                target: {
                  "@type": "EntryPoint",
                  urlTemplate:
                    "https://xeloba.ge/search?q={search_term_string}",
                },
                "query-input": "required name=search_term_string",
              },
              author: {
                "@type": "Organization",
                name: "xeloba.ge",
                logo: {
                  "@type": "ImageObject",
                  url: "https://xeloba.ge/assets/logo.png",
                  width: "180",
                  height: "60",
                },
                sameAs: [
                  "https://www.facebook.com/people/%E1%83%AE%E1%83%94%E1%83%9A%E1%83%9D%E1%83%91%E1%83%90-Xeloba/61555048217915/",
                  "https://www.instagram.com/xeloba7/?igsh=MWFrNmxzemt4ZmgzZA%3D%3D#",
                ],
              },
              offers: {
                "@type": "AggregateOffer",
                itemOffered: {
                  "@type": "Service",
                  name: "სარემონტო მომსახურება",
                  description:
                    "პროფესიონალი ხელოსნების მომსახურება საქართველოში",
                },
              },
            }}
          >
            <HomePage />
          </Page>
        }
      />

      <Route
        path="calculator"
        element={
          <Page
            title="კალკულატორი - სარემონტო ხარჯების გამოთვლა | xeloba.ge"
            description="კალკულატორი სარემონტო ხარჯების გამოსათვლელად. გამოთვალეთ რემონტის დაახლოებითი ღირებულება და ფართობი სწრაფად. დაზოგეთ დრო და ფული სამუშაოების დაგეგმვისას."
            keywords={[
              "სარემონტო ხარჯები",
              "სარემონტო ფართობი",
              "სარემონტო კალკულატორი",
              "ფასების გამოთვლა",
              "ფართობის გამოთვლა",
              "რემონტი",
              "ხელოსანი",
              "ბინის რემონტის ხარჯი",
              "რემონტის ბიუჯეტი",
              "მასალების ღირებულება",
              "რემონტის დაგეგმვა",
            ]}
            author="xeloba.ge"
            canonicalUrl="https://xeloba.ge/calculator"
            image="https://xeloba.ge/assets/logo.png"
            noindex={false}
            structuredData={{
              "@context": "https://schema.org",
              "@type": "CalculatorService",
              name: "კალკულატორი - xeloba.ge",
              url: "https://xeloba.ge/calculator",
              description: "კალკულატორი სარემონტო ფართობისა და ღირებულების გამოსათვლელად",
              provider: {
                "@type": "Organization",
                name: "xeloba.ge",
                url: "https://xeloba.ge",
              },
              offers: {
                "@type": "Offer",
                price: "0",
                priceCurrency: "GEL",
                availability: "https://schema.org/InStock",
              },
              mainEntityOfPage: {
                "@type": "WebPage",
                "@id": "https://xeloba.ge/calculator",
              },
            }}
          >
            <CalculatorPage />
          </Page>
        }
      />

      <Route
        path="search"
        element={
          <Page
            title="ხელოსნების ძებნა | xeloba.ge - იპოვეთ სანდო ხელოსანი თქვენი პროექტისთვის"
            description="მოძებნეთ პროფესიონალი ხელოსნები რეგიონის, პროფესიის, გამოცდილების, ფასისა და რეიტინგის მიხედვით. ნახეთ გამოხმაურებები და დაუკავშირდით პირდაპირ."
            keywords={[
              "ხელოსნის ძებნა",
              "მომსახურების მიმწოდებლები",
              "პროფესიონალები",
              "გაფილტვრა",
              "რეიტინგი",
              "გამოცდილება",
              "ხელოსნები თბილისში",
              "ხელოსნები რუსთავში",
              "ხელოსნები გორში",
              "ხელოსნები ქუთაისში",
              "ხელოსნები ბათუმში",
            ]}
            author="xeloba.ge"
            canonicalUrl="https://xeloba.ge/search"
            image="https://xeloba.ge/assets/logo.png"
            noindex={false}
            structuredData={{
              "@context": "https://schema.org",
              "@type": "SearchResultsPage",
              name: "ხელოსნების ძებნა",
              description: "ხელოსნების ძებნა სხვადასხვა კრიტერიუმით",
              mainEntity: {
                "@type": "ItemList",
              },
              potentialAction: {
                "@type": "SearchAction",
                target: {
                  "@type": "EntryPoint",
                  urlTemplate:
                    "https://xeloba.ge/search?q={search_term_string}",
                },
                "query-input": "required name=search_term_string",
              },
            }}
          >
            <SearchPage />
          </Page>
        }
      />

      <Route
        path="registration"
        element={
          <Page
            title="რეგისტრაცია ხელოსნებისა და კლიენტებისთვის | xeloba.ge"
            description="დარეგისტრირდით უფასოდ xeloba.ge-ზე როგორც ხელოსანი ან კლიენტი. მიიღეთ წვდომა საუკეთესო სამუშაო შესაძლებლობებთან და ხელოსნების ფართო ქსელთან."
            keywords={[
              "რეგისტრაცია",
              "ხელოსნის რეგისტრაცია",
              "კლიენტის რეგისტრაცია",
              "გაწევრიანება",
              "პლატფორმა",
              "უფასო რეგისტრაცია",
              "სარემონტო სერვისი",
              "ხელობა",
              "ანგარიშის შექმნა",
              "ხელოსნების პლატფორმა",
            ]}
            author="xeloba.ge"
            canonicalUrl="https://xeloba.ge/registration"
            image="https://xeloba.ge/registrationImg.jpg"
            noindex={false}
            structuredData={{
              "@context": "https://schema.org",
              "@type": "WebPage",
              name: "რეგისტრაცია ხელოსნებისა და კლიენტებისთვის",
              description: "ახალი მომხმარებლის რეგისტრაცია xeloba.ge-ზე",
              mainEntity: {
                "@type": "WebPageElement",
                isPartOf: {
                  "@type": "WebSite",
                  name: "xeloba.ge",
                  url: "https://xeloba.ge",
                },
                offers: {
                  "@type": "Offer",
                  price: "0",
                  priceCurrency: "GEL",
                  availability: "https://schema.org/InStock",
                  description: "უფასო რეგისტრაცია xeloba.ge-ზე",
                },
              },
            }}
          >
            <RegistrationPage />
          </Page>
        }
      />

      <Route path="category/:name" element={<CategoryPage />} />
      <Route path="craftsman/:userID" element={<CraftsmanProfile />} />
      <Route path="filter" element={<FilteredCraftsmen />} />

  <Route
        path="registration/craftsman-registration"
        element={<CraftsmanRegistration />}
      />

       <Route
        path="registration/client-registration"
        element={<ClientRegistration />}
      />

      <Route
        path="craftsman-registration/successful"
        element={<CraftsmanSuccessfulRegistration />}
      />

      <Route
        path="client-registration/successful"
        element={<ClientSuccessfulRegistration />}
      />

      <Route
        path="authorization"
        element={
          <Page
            title="ავტორიზაცია | xeloba.ge - შედით თქვენს ანგარიშზე"
            description="შედით თქვენს ანგარიშზე xeloba.ge-ზე. დაუკავშირდით პროფესიონალ ხელოსნებს ან მიიღეთ ახალი შეკვეთები."
            keywords={[
              "ავტორიზაცია",
              "შესვლა",
              "მომხმარებელი",
              "პირადი პროფილი",
              "კაბინეტი",
              "ხელოსნის ანგარიში",
              "კლიენტის ანგარიში",
              "პროფილზე შესვლა",
            ]}
            author="xeloba.ge"
            canonicalUrl="https://xeloba.ge/authorization"
            image="https://xeloba.ge/assets/logo.png"
            noindex={true}
            structuredData={{
              "@context": "https://schema.org",
              "@type": "LoginAction",
              target: {
                "@type": "EntryPoint",
                urlTemplate: "https://xeloba.ge/authorization",
                actionPlatform: "https://schema.org/WebPlatform",
              },
              description: "მომხმარებლის ავტორიზაცია xeloba.ge-ზე",
              provider: {
                "@type": "Organization",
                name: "xeloba.ge",
                url: "https://xeloba.ge",
              },
            }}
          >
            <Authorization />
          </Page>
        }
      />

      <Route
        path="verification/successful/:user_Id"
        element={<SuccessfulVerification />}
      />

      <Route
        path="craftsman/personal-page/:external_Id"
        element={
          <ProtectedCraftsmanRoute>
            <CraftsmanPersonalPage />
          </ProtectedCraftsmanRoute>
        }
      />

      <Route
        path="client/personal-page/:external_Id"
        element={
          <ProtectedCraftsmanRoute>
            <ClientPersonalPage />
          </ProtectedCraftsmanRoute>
        }
      />

      <Route path="google-account" element={<GoogleAccount />} />

      <Route path="fb-account" element={<FBAccount/>} />

      <Route path="/auth/callback" element={<AuthCallback />} />

      <Route path="fb-auth-callback" element={<FBAuthCallback />} />

      <Route
        path="verification/:user_Id/:phone_number"
        element={<Verification />}
      />

      <Route path="unauthorized" element={<UnauthorizedPage />} />

      <Route path="craftsman-only" element={<CraftsmanOnlyPage />} />

      <Route
        path="password-recovery"
        element={
          <Page
            title="პაროლის აღდგენა | xeloba.ge - აღადგინეთ წვდომა თქვენს ანგარიშზე"
            description="დაგავიწყდათ პაროლი? აღადგინეთ თქვენი xeloba.ge-ს ანგარიშის პაროლი მარტივად და უსაფრთხოდ რამდენიმე წუთში."
            keywords={[
              "პაროლის აღდგენა",
              "ანგარიშის მართვა",
              "უსაფრთხოება",
              "დაგავიწყდა პაროლი",
              "პაროლის განახლება",
              "ანგარიშზე წვდომა",
              "პაროლის შეცვლა",
            ]}
            author="xeloba.ge"
            canonicalUrl="https://xeloba.ge/password-recovery"
            image="https://xeloba.ge/assets/logo.png"
            noindex={false}
            structuredData={{
              "@context": "https://schema.org",
              "@type": "HowTo",
              name: "პაროლის აღდგენა xeloba.ge-ზე",
              description: "მომხმარებლის პაროლის აღდგენის პროცესი",
              step: [
                {
                  "@type": "HowToStep",
                  name: "შეიყვანეთ ტელეფონის ნომერი",
                  text: "შეიყვანეთ თქვენი რეგისტრირებული ტელეფონის ნომერი",
                },
                {
                  "@type": "HowToStep",
                  name: "შეიყვანეთ ახალი პაროლი",
                  text: "შექმენით ახალი, ძლიერი პაროლი",
                },
                {
                  "@type": "HowToStep",
                  name: "გაიმეორეთ პაროლი",
                  text: "პაროლი ზუსტად უნდა ემთხვეოდეს ახლად შექმნილ პაროლს",
                },
                {
                  "@type": "HowToStep",
                  name: "დაადასტურეთ",
                  text: "დააჭირეთ აღდგენის ღილაკს და შეიყვანეთ ერთჯერადი კოდი, რომელიც თქვენს ნომერზე გამოიგზავნა",
                },
              ],
            }}
          >
            <PasswordRecovery />
          </Page>
        }
      />

      <Route
        path="privacy-and-policy"
        element={
          <Page
            title="კონფიდენციალურობის პოლიტიკა | xeloba.ge - თქვენი პირადი ინფორმაციის დაცვა"
            description="გაეცანით xeloba.ge-ს კონფიდენციალურობის პოლიტიკას. ინფორმაცია იმის შესახებ, თუ როგორ ვაგროვებთ, ვიყენებთ და ვიცავთ თქვენს პერსონალურ მონაცემებს."
            keywords={[
              "კონფიდენციალურობის პოლიტიკა",
              "პირადი მონაცემები",
              "უსაფრთხოება",
              "მონაცემთა დაცვა",
              "პირადულობა",
              "პოლიტიკა",
              "წესები",
              "მომხმარებლის უფლებები",
            ]}
            author="xeloba.ge"
            canonicalUrl="https://xeloba.ge/privacy-and-policy"
            image="https://xeloba.ge/assets/logo.png"
            noindex={false}
            structuredData={{
              "@context": "https://schema.org",
              "@type": "WebPage",
              name: "კონფიდენციალურობის პოლიტიკა",
              description: "xeloba.ge-ს კონფიდენციალურობის პოლიტიკა",
              mainEntityOfPage: {
                "@type": "WebPage",
                "@id": "https://xeloba.ge/privacy-and-policy",
              },
              publisher: {
                "@type": "Organization",
                name: "xeloba.ge",
                logo: {
                  "@type": "ImageObject",
                  url: "https://xeloba.ge/images/logo.png",
                },
              },
            }}
          >
            <PrivacyAndPolicy />
          </Page>
        }
      />

<Route path="Q&A" element={<QandA />} />

<Route path="cookies-policy" element={<CookiesPolicy />} />

<Route path="vipmanager" element={<VIPManagerPage/>} />

<Route path="partners" element={<PartnerCompanies/>} />


<Route 
  path="job-request/create" 
  element={
    <Page
      title="განცხადების დამატება | xeloba.ge"
      description="დაამატეთ განცხადება ხელოსნის მოსაძებნად"
      keywords={["განცხადება", "ხელოსნის ძებნა"]}
      author="xeloba.ge"
      canonicalUrl="https://xeloba.ge/job-request/create"
      image="https://xeloba.ge/assets/logo.png"
      noindex={false}
    >
      <JobRequestCreate />
    </Page>
  } 
/>

<Route 
  path="job-requests" 
  element={
    <Page
      title="განცხადებების სია | xeloba.ge"
      description="მოძებნეთ თქვენი პროფესიის შესაბამისი სამუშაოები"
      keywords={["განცხადებები", "სამუშაოები", "ხელოსნები"]}
      author="xeloba.ge"
      canonicalUrl="https://xeloba.ge/job-requests"
      image="https://xeloba.ge/assets/logo.png"
      noindex={false}
    >
      <JobRequestList />
    </Page>
  } 
/>

<Route
  path="job-request/:id"
  element={
    <Page
      title="განცხადების დეტალები | xeloba.ge"
      description="განცხადების სრული ინფორმაცია"
      keywords={["განცხადება", "დეტალები", "ხელოსნები"]}
      author="xeloba.ge"
      canonicalUrl="https://xeloba.ge/job-request"
      image="https://xeloba.ge/assets/logo.png"
      noindex={false}
    >
      <JobRequestDetail />
    </Page>
  }
/>

<Route 
  path="job-request/:id/bid/create" 
  element={
    <Page
      title="შეთავაზების გაგზავნა | xeloba.ge"
      description="გაუგზავნეთ შეთავაზება განცხადებაზე"
      keywords={["ბიდი", "შეთავაზება", "ხელოსანი"]}
      author="xeloba.ge"
      canonicalUrl="https://xeloba.ge/job-request/bid/create"
      image="https://xeloba.ge/assets/logo.png"
      noindex={false}
    >
      <CraftsmanBidCreate />
    </Page>
  } 
/>

<Route 
  path="my-job-requests" 
  element={
      <Page
        title="ჩემი განცხადებები | xeloba.ge"
        description="მართეთ თქვენი განცხადებები და მიღებული შეთავაზებები"
        keywords={["განცხადებები", "ჩემი განცხადებები", "შეთავაზებები"]}
        author="xeloba.ge"
        canonicalUrl="https://xeloba.ge/my-job-requests"
        image="https://xeloba.ge/assets/logo.png"
        noindex={true}
      >
        <MyJobRequests />
      </Page>
  } 
/>

<Route path="/bid-packages" element={<BidPackages />} />

<Route 
  path="/bid-purchase/:packageId" 
  element={
    <ProtectedCraftsmanOnlyRoute>
      <BidPurchase />
    </ProtectedCraftsmanOnlyRoute>
  } 
/>

<Route path="/craftsman/bid-transactions" element={<BidTransactions />} />

    </Route>
  )
);

export const MainContext = createContext<MainContextInteface>({
  menuBar: false,
  setMenuBar: () => {},
  selectedNavigation: "home",
  setSelectedNavigation: () => {},
  searchByCity: "",
  setSearchByCity: () => {},
  searchByDistrict: "",
  setSearchByDistrict: () => {},
  searchByProfession: "",
  setSearchByProfession: () => {},
  searchByVerification: "",
  setSearchByVerification: () => {},
  searchByExperience: "",
  setSearchByExperience: () => {},
  searchByPriceFrom: "",
  setSearchByPriceFrom: () => {},
  searchByPriceUpTo: "",
  setSearchByPriceUpTo: () => {},
  getCraftsmenData: [],
  getClientData: [],
  serverBaseUrl: "",
  titleForCategory: "",
  setTitleForCategory: () => {},
  loading: true,
  filteredCraftsmen: [],
  totalPages: 0,
  errorForFilter: "",
  currentPage: 1,
  setCurrentPage: () => {},
  totalCraftsmen: 0,
  scrolled: false,
  setScrolled: () => {},
});

interface PaginatedResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: CraftsmanDataInterface[];
}

function App() {
  const [menuBar, setMenuBar] = useState<boolean>(false);
  const [selectedNavigation, setSelectedNavigation] = useState<string>("home");
  const [searchByCity, setSearchByCity] = useState<string>("");
  const [searchByDistrict, setSearchByDistrict] = useState<string>("");
  const [searchByProfession, setSearchByProfession] = useState<string>("");
  const [searchByVerification, setSearchByVerification] = useState<string>("");
  const [searchByExperience, setSearchByExperience] = useState<string>("");
  const [searchByPriceFrom, setSearchByPriceFrom] = useState<string>("");
  const [searchByPriceUpTo, setSearchByPriceUpTo] = useState<string>("");
  const [titleForCategory, setTitleForCategory] = useState<string>("");
  const [scrolled, setScrolled] = useState(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [filteredCraftsmen, setFilteredCraftsmen] = useState<
    CraftsmanDataInterface[]
  >([]);
  const [totalCraftsmen, setTotalCraftsmen] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [errorForFilter, setErrorForFilter] = useState<string>("");
  const pageSize = 24; // ერთ გვერდზე გამოსაჩენი ხელოსნების რაოდენობა
  const [currentPage, setCurrentPage] = useState<number>(1);

  const [getCraftsmenData, setGetCraftsmenData] = useState<
    CraftsmanDataInterface[]
  >([]);
  const [getClientData, setGetClientData] = useState<ClientDataInterface[]>([]);
  const serverBaseUrl = "https://xeloba.ge/Y2BQDEDHzHua2ls/";
  // const serverBaseUrl = "http://localhost:8000/xelapi/";


  // Google Analytics ინიციალიზაცია
useEffect(() => {
  // შევამოწმოთ cookies-ის სტატუსი და ვადა
  const checkConsentAndInitAnalytics = () => {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    const analyticsEnabled = localStorage.getItem('analyticsEnabled');
    const consentTimestamp = localStorage.getItem('consentTimestamp');
    
    // ვადის შემოწმება
    if (consentTimestamp) {
      const now = Date.now();
      const CONSENT_DURATION = 7 * 24 * 60 * 60 * 1000;  // 7 დღე მილიწამებში
      // const CONSENT_DURATION = 1 * 60 * 1000; // 1 წუთი (ტესტისთვის)
      const timeElapsed = now - parseInt(consentTimestamp);
      
      if (timeElapsed > CONSENT_DURATION) {
        // ვადა გასულია - წავშალოთ ყველაფერი
        localStorage.removeItem('cookiesAccepted');
        localStorage.removeItem('consentTimestamp');
        localStorage.removeItem('analyticsEnabled');
        localStorage.removeItem('marketingEnabled');
        return;
      }
    }
    
    // Analytics ინიციალიზაცია მხოლოდ consent-ის შემთხვევაში
    if (cookiesAccepted === 'all' || 
        (cookiesAccepted === 'custom' && analyticsEnabled === 'true')) {
      // console.log('🎯 Analytics consent found - Initializing GA');
      initGA(TRACKING_ID);
      logPageView();
    } 
    // else {
    //   console.log('⚠️ No analytics consent - GA not initialized');
    // }
  };
  
  checkConsentAndInitAnalytics();
}, []);

  //get craftsman data
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${serverBaseUrl}craftsman/`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const responseData: CraftsmanDataInterface[] = await response.json();
        setGetCraftsmenData(responseData);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  //get client data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${serverBaseUrl}client/`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const responseData = await response.json();

        // Type assertion: ვუთითებთ, რომ responseData არის ClientDataInterface ტიპის ობიექტი.
        const clientArray = Object.values(
          responseData
        ) as ClientDataInterface[];

        setGetClientData(clientArray); // ახლა ტიპები შესაბამისობაშია.
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  //ხელოსნების გაფილტვრა პროფესიების მიხედვით და კატეგორიებად დაყოფა.
  useEffect(() => {
    const fetchCraftsmen = async () => {
      if (!titleForCategory) {
        setLoading(false);
        setErrorForFilter("კატეგორია ვერ მოიძებნა");
        return;
      }

      try {
        setLoading(true);

        // API-ის მოთხოვნა პროფესიით გაფილტრული ხელოსნების მისაღებად
        const response = await fetch(
          `${serverBaseUrl}get-craftsmen-by-profession/?profession=${encodeURIComponent(
            titleForCategory
          )}&page=${currentPage}&page_size=${pageSize}`
        );
       

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data: PaginatedResponse = await response.json();
        // მიღებული მონაცემების დამუშავება
        setFilteredCraftsmen(data.results);
        setTotalCraftsmen(data.count);

        // გამოვთვალოთ გვერდების საერთო რაოდენობა
        setTotalPages(Math.ceil(data.count / pageSize));
        setErrorForFilter("");
      } catch (error) {
        console.error("Error fetching craftsmen:", error);
        setErrorForFilter("მონაცემების მიღება ვერ მოხერხდა");
        setFilteredCraftsmen([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCraftsmen();
  }, [titleForCategory, currentPage, serverBaseUrl, pageSize]);

  //ხელოსნების ფილტრაცია
  const fetchFilteredCraftsmen = async () => {
    // თუ კატეგორიის გვერდზე ვიმყოფებით და titleForCategory არის განსაზღვრული,
    // არ გამოვიყენოთ ეს ფუნქცია (იმის მაგივრად გამოიყენება fetchCraftsmen)
    if (titleForCategory) {
      return;
    }

    setLoading(true);
    setErrorForFilter("");

    try {
      // ვქმნით ახალ URLSearchParams ობიექტს API მოთხოვნისთვის
      const params = new URLSearchParams();

      // ვამატებთ გვერდის ნომერს
      params.append("page", currentPage.toString());

      // ფილტრის პარამეტრებს ვამატებთ მხოლოდ იმ შემთხვევაში, თუ ისინი განსაზღვრულია
      if (searchByCity) params.append("searchByCity", searchByCity);
      if (searchByDistrict) params.append("searchByDistrict", searchByDistrict);
      if (searchByProfession)
        params.append("searchByProfession", searchByProfession);
      if (searchByVerification)
        params.append("searchByVerification", searchByVerification);
      if (searchByExperience)
        params.append("searchByExperience", searchByExperience);
      if (searchByPriceFrom)
        params.append("searchByPriceFrom", searchByPriceFrom);
      if (searchByPriceUpTo)
        params.append("searchByPriceUpTo", searchByPriceUpTo);

      // API მოთხოვნის გაგზავნა
      const response = await fetch(
        `${serverBaseUrl}get-filtered-craftsmen/?${params}`
      );

      if (!response.ok) {
        // არასწორი გვერდის შემთხვევაში (404), ვატრიალებთ ხელახალი მოთხოვნით, პირველ გვერდზე
        if (response.status === 404 && currentPage > 1) {
          setCurrentPage(1);
          return; // გავდივართ ფუნქციიდან, რადგან setCurrentPage გამოიწვევს useEffect-ის ხელახალ გაშვებას
        }
        // throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: PaginatedResponse = await response.json();

      // მიღებული მონაცემების დამუშავება
      setFilteredCraftsmen(data.results);
      setTotalCraftsmen(data.count);
      // გვერდების რაოდენობის გამოთვლა
      const pages = Math.ceil(data.count / pageSize);
      setTotalPages(pages);

      // თუ მიმდინარე გვერდი აღემატება არსებული გვერდების რაოდენობას, ვაბრუნებთ პირველ გვერდზე
      if (currentPage > pages && pages > 0) {
        setCurrentPage(1);
      }

      setErrorForFilter("");
    } catch (err) {
      console.error("Error fetching filtered craftsmen:", err);
      setErrorForFilter(
        "მონაცემების ჩატვირთვა ვერ მოხერხდა. გთხოვთ, სცადოთ მოგვიანებით."
      );
      setFilteredCraftsmen([]);
    } finally {
      setLoading(false);
    }
  };

  // useEffect მოდიფიკაცია - დავამატოთ დამოკიდებულების მასივში ყველა ცვლადი,
  useEffect(() => {
    // კატეგორიის გვერდზე რომ არ იმუშაოს ამ ფუნქციამ
    if (!titleForCategory) {
      fetchFilteredCraftsmen();
    }
  }, [
    currentPage,
    serverBaseUrl,
    pageSize,
    searchByCity,
    searchByDistrict,
    searchByProfession,
    searchByVerification,
    searchByExperience,
    searchByPriceFrom,
    searchByPriceUpTo,
    titleForCategory,
  ]);

  return (
    <HelmetProvider>
      <div className="App">
        <AuthListener />
        <Suspense fallback={<LoadingBar />}>
          <MainContext.Provider
            value={{
              getCraftsmenData,
              getClientData,
              menuBar,
              setMenuBar,
              selectedNavigation,
              setSelectedNavigation,
              searchByCity,
              setSearchByCity,
              searchByDistrict,
              setSearchByDistrict,
              searchByProfession,
              setSearchByProfession,
              searchByVerification,
              setSearchByVerification,
              searchByExperience,
              setSearchByExperience,
              searchByPriceFrom,
              setSearchByPriceFrom,
              searchByPriceUpTo,
              setSearchByPriceUpTo,
              serverBaseUrl,
              titleForCategory,
              setTitleForCategory,
              loading,
              filteredCraftsmen,
              totalPages,
              errorForFilter,
              currentPage,
              setCurrentPage,
              totalCraftsmen,
              scrolled,
              setScrolled
            }}
          >
            <NotificationsProvider>
            <RouterProvider router={router} />
            </NotificationsProvider>
          </MainContext.Provider>
        </Suspense>
      </div>
    </HelmetProvider>
  );
}

export default App;

